import { BaseModel } from './base.model';

export class TimeZone extends BaseModel {
  public id: number;
  public group_id: number;
  public label: string;
  public value: string;
  public active: boolean;

  constructor(data) {
    super(data, {
      num: ['id', 'group_id'],
      bool: ['active'],
    });
  }
}
